import { StringObject } from "../../objects/StringObject";

type CenterState = {
  cx: number;
  cy: number;
  valid: boolean;
  ro?: ResizeObserver;
  el?: HTMLElement;
};

export class CenterCache {
  private map = new WeakMap<StringObject, CenterState>();
  private all: Set<StringObject> = new Set();

  attach(obj: StringObject) {
    if (this.map.has(obj)) return;
    const el = obj.htmlElement;
    const st: CenterState = { cx: 0, cy: 0, valid: false, el };
    st.ro = new ResizeObserver(() => {
      st.valid = false;
    });
    st.ro.observe(el);
    this.map.set(obj, st);
    this.all.add(obj);
  }

  detach(obj: StringObject) {
    const st = this.map.get(obj);
    if (!st) return;
    st.ro?.disconnect();
    this.map.delete(obj);
    this.all.delete(obj);
  }

  invalidate(id: string) {
    this.all.forEach((o) => {
      if (o.id === id) {
        const st = this.map.get(o);
        if (st) st.valid = false;
      }
    });
  }

  invalidateAll() {
    this.all.forEach((o) => {
      const st = this.map.get(o);
      if (st) st.valid = false;
    });
  }

  getCenter(obj: StringObject): { cx: number; cy: number } {
    const st = this.map.get(obj);
    if (!st || !st.el) return { cx: 0, cy: 0 };
    if (!st.valid) {
      const r = st.el.getBoundingClientRect();
      st.cx = r.left + r.width / 2;
      st.cy = r.top + r.height / 2;
      st.valid = true;
    }
    return { cx: st.cx, cy: st.cy };
  }
}
